export const aiScriptSpreadsheetKey = (
  businessId: string | null,
  runId: string | null,
) => ["ai-script-spreadsheet", businessId, runId] as const;

export const aiScriptStatementKey = (
  businessId: string | null,
  runId: string | null,
  technicianId: string | null = null,
) => ["ai-script-statement", businessId, runId, technicianId] as const;

export const aiScriptStatementPrefixKey = (
  businessId: string | null,
  runId: string | null,
) => ["ai-script-statement", businessId, runId] as const;

export const aiScriptCellOverridesKey = (
  businessId: string | null,
  runId: string | null,
) => ["ai-script-cell-overrides", businessId, runId] as const;

export const aiScriptCellOverrideHistoryPrefixKey = (
  businessId: string | null,
  runId: string | null,
) => ["ai-script-cell-override-history", businessId, runId] as const;

export const aiScriptCellOverrideHistoryKey = (
  businessId: string | null,
  runId: string | null,
  overrideKey: string | null,
) =>
  [
    ...aiScriptCellOverrideHistoryPrefixKey(businessId, runId),
    overrideKey,
  ] as const;

export const aiScriptOverrideCandidatesKey = (
  businessId: string | null,
  runId: string | null,
  overrideId: string | null,
) => ["ai-script-override-candidates", businessId, runId, overrideId] as const;

export const aiScriptManualRowsKey = (
  businessId: string | null,
  runId: string | null,
) => ["ai-script-manual-rows", businessId, runId] as const;
